var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevealPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2963 12.9434C14.9988 13.2136 14.64 13.4303 14.2413 13.5806C13.8427 13.7309 13.4123 13.8118 12.9759 13.8183C12.5396 13.8248 12.1061 13.7569 11.7014 13.6186C11.2967 13.4802 10.9291 13.2744 10.6205 13.0132C10.3119 12.7521 10.0686 12.4411 9.90514 12.0986C9.74168 11.7562 9.66141 11.3894 9.66911 11.0202C9.67681 10.6509 9.77232 10.2868 9.94996 9.94946C10.1276 9.61213 10.3837 9.30853 10.703 9.05677M19.4347 16.4451C17.5828 17.6395 15.3279 18.3012 12.9997 18.3334C5.41634 18.3334 1.08301 11.0001 1.08301 11.0001C2.43056 8.87518 4.29957 7.01866 6.56467 5.5551L19.4347 16.4451ZM10.7247 3.88677C11.4704 3.73908 12.2338 3.66525 12.9997 3.66677C20.583 3.66677 24.9163 11.0001 24.9163 11.0001C24.2587 12.0411 23.4745 13.0211 22.5763 13.9243L10.7247 3.88677Z",
    stroke: "#1D1D1F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08301 0.916748L24.9163 21.0834",
    stroke: "#1D1D1F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevealPasswordIcon);
export default __webpack_public_path__ + "static/media/reveal-password-icon.c352a3901d0691d53fa9159bf7b33b8e.svg";
export { ForwardRef as ReactComponent };